import type { FaireProductEntity } from "../../entity_types/product";

export const p_naxnq9wsnr: FaireProductEntity = {
  token: "p_naxnq9wsnr",
  type: "product",
  name: "Single-Breasted Long Sleeve Blazer",
  brandToken: "b_nd6psatxbw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5beed1293d18ed189c86d19717e08acdb2f706b891c7b223cd677bbba96297ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44e2a28a79f86887bf241f24c337cf3a0a892afc0f6f99b30f6458fecc2e8c9a.jpeg",
    "https://cdn.faire.com/fastly/d151e7b18b765b30605917511b46f5a9d998392e2d2ceabaa7e7473fdeea641f.jpeg",
    "https://cdn.faire.com/fastly/2c69c1ebdeefde309349e9376eccc20d75140e5b53c310396ba97820e8e59a28.jpeg",
    "https://cdn.faire.com/fastly/40e628705dfeea85ab1c438f0310ffb064def253a65f64e6a5eebdd08327a465.jpeg",
    "https://cdn.faire.com/fastly/8a0cb9c119e26ff07b1fbd27140621db423a8da4be77e6b9ee1d52770a4d6781.png",
  ],
  priceDollars: 34.58,
  description:
    "This classic single-breasted blazer features a tailored fit with structured shoulders and a sleek notch lapel. The lightweight fabric and versatile design make it perfect for both business and casual looks. Pair it with trousers or jeans for an effortlessly polished style.\n\nMaterial | Weight:\nMaterial: Polyester blend\nWeight: Approximately 350g\n",
  tags: [],
  msrpDollars: 69.15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:08.382Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
